import api from '../index';
export var submitFeed = function submitFeed(url, params) {
    return api.post(url, params);
};